var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReservationWaitToConfirm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 0C4.00909 0 0 4.00909 0 9C0 13.9909 4.00909 18 9 18C13.9909 18 18 13.9909 18 9C18 4.00909 13.9909 0 9 0ZM14.4818 10.4727C14.4 10.8 14.0727 10.9636 13.7455 10.8818L9.16364 9.98182C9 9.98182 8.83636 9.81818 8.67273 9.73636C8.34545 9.57273 8.18182 9.32727 8.18182 9L8.34545 2.45455C8.34545 2.04545 8.67273 1.8 9 1.8C9.32727 1.8 9.65455 2.12727 9.65455 2.45455L9.73636 8.1L13.9909 9.57273C14.4 9.65455 14.5636 10.0636 14.4818 10.4727Z",
    fill: "#428BC1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReservationWaitToConfirm);
export default __webpack_public_path__ + "static/media/reservation-wait-to-confirm.2c0bcfdccacfe125f63bea44d00ef401.svg";
export { ForwardRef as ReactComponent };